<div
  *ngIf="isLoading | async"
  class="h-20 w-20 animate-spin rounded-full border-[10px] border-primary-100 border-r-primary-400"
  role="status"
>
  <span class="cdk-visually-hidden" i18n>Ładowanie...</span>
</div>
